import { render, staticRenderFns } from "./MitHomePage.vue?vue&type=template&id=00dbfe8d&scoped=true"
import script from "./MitHomePage.vue?vue&type=script&lang=js"
export * from "./MitHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dbfe8d",
  null
  
)

export default component.exports